export const PLEO_GUIDE_AWARENESS_COMPLETED_VALUE = 'completed'
